import PropertyForm from "../../components/Property/PropertyForm";

export default function PropertyEditPage() {
  return <PropertyForm edit />;
}
